import React from 'react';
import { Link } from 'react-router-dom';
import '../../pages/ProductsPage.css'; 
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  // Featured products based on company's specializations
  const featuredProducts = [
    {
      id: 1,
      name: 'Electroplated Diamond & CBN Tools',
    //   description: 'Single layer abrasive tools with sharp, aggressive cutting edges ideal for high precision grinding and drilling operations.',
      image: 'ed_cbn_tool.jpg'
    },
    {
      id: 2,
      name: 'Tungsten Carbide Dies & Wear Parts',
    //   description: 'High-grade carbide components engineered to withstand intense pressures in metal forming and extrusion processes.',
      image: 'tungsten-carbide.JPG'
    },
    {
      id: 3,
      name: 'Diamond Dressers & PCD/PCBN Tools',
    //   description: 'High-quality synthetic and natural diamond tools for maintaining grinding wheel profiles and precision cutting.',
      image: 'diamond-dressers.JPG'
    },
    // {
    //   id: 4,
    //   name: 'Vacuum Brazed Tools',
    //   description: 'Robust cutting tools with diamond or CBN particles directly brazed onto the surface for tackling the toughest materials.',
    //   image: 'placeholder.jpg',
    //   industries: ['Construction', 'Stone Processing', 'Mining']
    // }
  ];

  return (
    <section className="featured-products-section home-section">
      <div className="section-header">
        <h2 className="section-title">Our Featured Products</h2>
        <p className="section-subtitle">
          Explore our wide range of high-quality tools designed to meet the exacting standards of today's industrial needs
        </p>
      </div>

      {/* SAME GRID AS PRODUCTS PAGE */}
      <div className="products-grid">
        {featuredProducts.map(product => (
          <Link 
            key={product.id}
            to={`/products?id=${product.id}`}
            className="product-card"
            style={{ textDecoration: 'none' }}
          >
            <div className="product-image-container">
              <img
                src={`/images/products/${product.image}`}
                alt={product.name}
              />
            </div>

            <h3 className="product-name">{product.name}</h3>
          </Link>
        ))}
      </div>

      <div className="section-action">
        <Link to="/products" className="btn btn-large">
          View All Products
        </Link>
      </div>
    </section>
  );
};

export default FeaturedProducts;